 import a from "./1.jpg"
 export const products=[
    {
    id:1,
  image: "https://s2.uupload.ir/files/the_stonekeeper_lpqf.jpg",
category: "kids",

 title: "The Stonekeeper ",
  Author: "Kazu Kibuishi",
price: 19.52,
describtion:"The first book in Kazu Kibuishi's #1 New York Times bestselling series that features a beautiful but dangerous world of new friends, giant robots, and shadowy enemies!After the tragic death of their father, Emily and Navin move with their mother to the home of her deceased great-grandfather. The strange house proves to be dangerous. Before long, a tentacled creature lures the kids' mom through a door in the basement"
  ,pages: "192",
  publishData: "June 05 , 2018",
  dimensions: "6 * 8.1 * .5 inches"
},{
  id:2,
  image: "https://s2.uupload.ir/files/fruits_89wy.jpg",
category: "kids",

 title: "Basket Collector's Edition",
  Author: "Natsuki Takaya",
price:18.60 ,
describtion:
"After a family tragedy turns her life upside down, plucky high schooler Tohru Honda takes matters into her own hands and moves out...into a tent! Unfortunately for her, she pitches her new home on private land belonging to the mysterious Sohma clan, and it isn't long before the owners discover her secret.But, as Tohru quickly finds out when the family offers to take her in, the Sohmas have a secret of their own--when touched by the opposite sex, they turn into the animals of the Chinese Zodiac!A perennial favorite of fans and librarians alike, Natsuki Takaya's beloved bestselling Fruits Basket series returns to print in gorgeous deluxe English-language omnibus editions with beautiful full-color illustrations that are not to be missed!",
  pages: "392",
  publishData: "June 28, 2016",
  dimensions: "5.7 X 8.0 X 1.4 inches | 1.14 pounds"
},
{  id:3,
  image: "https://s2.uupload.ir/files/the_cardboard_kingdom_6yp.jpg",
category: "kids",

 title: "The Cardboard Kingdom",
  Author: "Chad Sell",
price: 19.26,
describtion:
"Perfect for fans of Raina Telgemeier, Awkward, and All's Faire in Middle School, this graphic novel follows a neighborhood of kids who transform ordinary cardboard into fantastical homemade costumes as they explore conflicts with friends, family, and their own identity.A breath of fresh air, this tender and dynamic collection is a must-have. --Kirkus, Starred Welcome to a neighborhood of kids who transform ordinary boxes into colorful costumes, and their ordinary block into cardboard kingdom. This is the summer when sixteen kids encounter knights and rogues, robots and monsters--and their own inner demons--on one last quest before school starts again.",
  pages: "288",
  publishData: "June 05, 2018",
  dimensions: "5.9 X 8.1 X 0.9 inches | 1.35 pounds"
},
{  id:4,
  image: "https://s2.uupload.ir/files/9780399186783_koy0.jpg",
category: "kids",

 title: "Birdie and Me",
  Author: "J. M. M. Nuanez   ",
price: 8.66,
describtion:
"Birdie, searching for the place where they can be their true and best selves.After their mama dies, Jack and Birdie find themselves without a place to call home. And when Mama's two brothers each try to provide one--first sweet Uncle Carl, then gruff Uncle Patrick--the results are funny, tender, and tragic.They're also somehow . . . spectacular.With voices and characters that soar off the page, J. M. M. Nuanez's debut novel depicts an unlikely family caught in a situation none of them would have chosen, and the beautiful ways in which they finally come to understand one another.",
  pages: "256",
  publishData: "February 16, 2021",
  dimensions: "5.0 X 7.7 X 0.8 inches | 0.42 pounds"
},{  id:5,
  image: "https://s2.uupload.ir/files/yotsuba_amp__2xfp.jpg",
category: "kids",

 title: "Yotsuba&!",
  Author: "Kiyohiko Azuma ",
price:12.9 ,
describtion:
"Hello! This is Koiwai Yotsuba, Yotsuba Koiwai...um, YOTSUBA! Yotsuba moved with Daddy to a new house from our old house waaaaaaay over there! And moving's fun 'cos people wave! (Ohhhh!!) And Yotsuba met these nice people next door and made friends to play with (one of 'em acted like one of those bad strangers Daddy told Yotsuba not to go with, but it was okay in the end). I hope we get to play a lot. And eat ice cream! And-and-and...oh yeah! You should come play with Yotsuba too!",
  pages: "208",
  publishData: "September 01, 2009",
  dimensions: "5.1 X 7.54 X 0.69 inches | 0.48 pounds"
},{  id:6,
  image: "https://s2.uupload.ir/files/9780316167659__fh0q.jpg",
category: "kids",

 title: "Away with Words!",
  Author: "Mary Ann Hoberman   Perr",
price:17.66 ,
describtion:
"Children's Poet Laureate and New York Times bestselling author Mary Ann HobermanWords are remarkable / Here is a book / Where you'll not only listen / You also will look / Where you'll not only look / But you also will think / About words and their meanings / And how in the blink / Of an eye or a letter / Their meanings can change / Words are remarkable / Language is strange!In this poetry collection, the masterful Mary Ann Hoberman celebrates the joy of wordplay with poems about the alphabet, assonance, alliteration, grammar and punctuation, similes, rhythm and rhyme, and so much more!"
 , pages: "64",
  publishData: "March 08, 2022",
  dimensions: "8.4 X 10.1 X 0.5 inches | 1.05 pounds"
},

{  id:8,
  image: "https://s2.uupload.ir/files/9780689840456_bjfk.jpg",
category: "kids",

 title: "Ashley Bryan",
  Author: "Ashley Bryan  ",
price:7.88 ,
describtion:"https://s2.uupload.ir/files/9780689840456_bjfk.jpg",
  pages: "32",
  publishData: "January 01, 2001",
  dimensions: "7.68 X 11.94 X 0.11 inches | 0.38 pounds"
},
{  id:9,
  image: "https://s2.uupload.ir/files/9780547124933_x42v.jpg",
category: "comedy",

 title: "A Stick Is an Excellent",
  Author: "Marilyn Singer   L ",
price:17.66 ,
describtion:"A paean to play from an award-winning poet and a New York Times best-selling illustrator. The trappings of childhood change from generation to generation, but there are some timeless activities that every kid loves. Marilyn Singer and LeUyen Pham celebrate these universal types of play, from organized games such as hide-and-seek and hopscotch to imaginative play such as making mud soup or turning a stick into a magic wand. Lyrical poems and bold illustrations capture the energy of a group of children in one neighborhood as they amuse themselves over the course of a summer day. At a time when childhood obesity rates are soaring and money is tight for many families, here is a book that invites readers to join in the fun of active play with games that cost nothing.",
  pages: "40",
  publishData: "February 28, 2012",
  dimensions: "8.2 X 10.1 X 0.4 inches | 0.7 pounds"
},
{  id:10,
  image: "https://s2.uupload.ir/files/9780525517498_v3z0.jpg",
category: "comedy",

 title: "The Whispers",
  Author: "Greg Howard  ",
price:25.66 ,
describtion:"A middle grade debut that's a heartrending coming-of-age tale, perfect for fans of Bridge to Terabithia and Counting By 7s. Eleven-year-old Riley believes in the whispers, magical fairies that will grant you wishes if you leave them tributes. Riley has a lot of wishes. He wishes bullies at school would stop picking on him. He wishes Dylan, his 8th grade crush, liked him, and Riley wishes he would stop wetting the bed. But most of all, Riley wishes for his mom to come back home. She disappeared a few months ago, and Riley is determined to crack the case. He even meets with a detective, Frank, to go over his witness statement time and time again.",
  pages: "256",
  publishData: "January 15, 2019",
  dimensions: "5.7 X 8.3 X 1.2 inches | 0.8 pounds"
},
{  id:15,
  image: "https://s2.uupload.ir/files/9781541598690_jz8b.jpg",
category: "comedy",

 title: "Rumble and Roar",
  Author: "Sue Fliess ",
price:18.59 ,
describtion:"March 01, 2022",
  pages: "58",
  publishData: "The roar of a waterfall, the chirp of insects, the thump of a heartbeat--sound is all around us! Rhyming text and atmospheric illustrations present four children in different parts of the world who encounter all sorts of sounds.",
  dimensions: "10.1 X 9.8 X 0.4 inches | 0.9 pounds"
},
{  id:11,
  image: "https://s2.uupload.ir/files/9780525554837_x6xv.jpg",
category: "love",

 title: "The Ship We Built",
  Author: "Lexie Bean  ",
price:15.88 ,
describtion:"Tender and wise, The Ship We Built is about the bravery it takes to stand up for yourself--even to those you love--and the power of finding someone who treasures you for everything you are. Sometimes I have trouble filling out tests when the name part feels like a test too. . . . When I write letters, I love that you have to read all of my thoughts and stories before I say any name at all. You have to make it to the very end to know.Rowan has too many secrets to write down in the pages of a diary. And if he did, he wouldn't want anyone he knows to read them. He understands who he is and what he likes, but it's not safe for others to find out. Now the kids at school say Rowan's too different to spend time with. He's not the right kind of girl, and he's not the right kind of boy. His mom ignores him. And at night, his dad hurts him in ways he's not ready to talk about yet.",
  pages: "288",
  publishData: "May 26, 2020",
  dimensions: "5.5 X 8.3 X 1.1 inches | 0.85 pounds"
},
{  id:12,
  image: "https://s2.uupload.ir/files/9780374389284_0n4.jpg",
category: "kids",

 title: "Tomorrow Is New Year's Day",
  Author: " Aram Kim ",
price:12.44 ,
describtion:"From Korean American author-illustrator Aram Kim, Tomorrow is New Year's Day follows a little girl sharing the fun customs of Seollal--the Korean Lunar New Year--with her classmates.Seollal, the Korean Lunar New Year, is Mina's favorite day of the year.Mina can't wait to share the customs of Seollal with all of her friends at school. She will show her classmates her colorful hanbok, demonstrate how to do sebae, and then everyone will make tasty tteokguk in the cooking room. Yum! Her little brother may even join in on the fun... if he can find a way out of his bad mood.In this joyful book about sharing age-old cultural celebrations with new friends, Aram Kim has created a must-have book for the New Year's season. A glossary of Korean terms, with pronunciation guide, is included.",
  pages: "40",
  publishData: "December 27, 2022",
  dimensions: "8.7 X 11.2 X 0.4 inches | 0.8 pounds"
},
{  id:13,
  image: "https://s2.uupload.ir/files/9780593123997_892s.jpg",
category: "love",

 title: "Grumpy Monkey",
  Author: "Suzanne Lang  ",
price:8.36 ,
describtion:"The hilarious #1 New York Times bestselling picture book about a chimpanzee in a very bad mood--perfect for young children learning how to deal with confusing feelings, especially during the transition back to school.Jim the chimpanzee is in a terrible mood for no good reason. His friends can't understand it--how can he be in a bad mood when it's SUCH a beautiful day? They have lots of suggestions for how to make him feel better. But Jim can't take all the advice...and has a BIT of a meltdown. Could it be that he just needs a day to feel grumpy?",
  pages: "32",
  publishData: "October 15, 2019",
  dimensions: "7.4 X 7.4 X 0.8 inches | 0.94 pounds"
},
{  id:14,
  image: "https://s2.uupload.ir/files/9781452111735_prlt.jpg",
category: "love",

 title: "Goodnight, Goodnight",
  Author: " Sherri Duskey Rinker   ",
price: 7.43,
describtion:"As the sun sets behind the big construction site, all the hardworking trucks get ready to say goodnight.One by one, Crane Truck, Cement Mixer, Dump Truck, Bulldozer, and Excavator finish their work and lie down to rest--so they'll be ready for another day of rough and tough construction play!An unabridged board book for kids, this version of the bestselling and beloved Goodnight, Goodnight Construction Site book is perfect for small hands. Even the roughest, toughest readers will want to turn off their engines, rest their wheels, and drift to sleep with this sweet and soothing story. Vibrant illustrations and gentle rhyming text make this construction book for kids a surefire bedtime favorite.",
  pages: "30",
  publishData: "February 14, 2017",
  dimensions: "5.9 X 5.7 X 0.7 inches | 0.5 pounds"
},
{  id:15,
  image: a,
category: "love",

 title: "I Want a Better Catastrophe",
  Author: " Andrew Boyd ",
price: 27.43,
describtion:
"An existential manual for tragic optimists, can-do pessimists, and compassionate doomers With global warming projected to rocket past the 1.5°C limit, lifelong activist Andrew Boyd is thrown into a crisis of hope, and off on a quest to learn how to live with the (impossible news) of our climate doom.He searches out eight of today's leading climate thinkers -- from activist Tim DeChristopher to collapse-psychologist Jamey Hecht, grassroots strategist adrienne maree brown, eco-philosopher Joana Macy, and Indigenous botanist Robin Wall Kimmerer -- asking them: Is it really the end of the world? and if so, now what?With gallows humor and a broken heart, Boyd steers readers through their climate angst as he walks his own. Boyd's journey takes him from storm-battered coastlines to pipeline blockades and hopelessness workshops. Along the way, he maps out our existential options, and tackles some familiar dilemmas:  Should I bring kids into such a world?   Can I lose hope when others can't afford to?  and  Why the fuck am I recycling?",
pages: "300",
  publishData: "February 14, 2017",
  dimensions: "5.9 X 5.7 X 0.7 inches | 0.5 pounds"
},{
  id:16,
image: "https://s2.uupload.ir/files/the_stonekeeper_lpqf.jpg",
category: "kids",

title: "The Stonekeeper ",
Author: "Kazu Kibuishi",
price: 19.52,
describtion:"The first book in Kazu Kibuishi's #1 New York Times bestselling series that features a beautiful but dangerous world of new friends, giant robots, and shadowy enemies!After the tragic death of their father, Emily and Navin move with their mother to the home of her deceased great-grandfather. The strange house proves to be dangerous. Before long, a tentacled creature lures the kids' mom through a door in the basement"
,pages: "192",
publishData: "June 05 , 2018",
dimensions: "6 * 8.1 * .5 inches"
},{
id:17,
image: "https://s2.uupload.ir/files/fruits_89wy.jpg",
category: "kids",

title: "Basket Collector's Edition",
Author: "Natsuki Takaya",
price:18.60 ,
describtion:
"After a family tragedy turns her life upside down, plucky high schooler Tohru Honda takes matters into her own hands and moves out...into a tent! Unfortunately for her, she pitches her new home on private land belonging to the mysterious Sohma clan, and it isn't long before the owners discover her secret.But, as Tohru quickly finds out when the family offers to take her in, the Sohmas have a secret of their own--when touched by the opposite sex, they turn into the animals of the Chinese Zodiac!A perennial favorite of fans and librarians alike, Natsuki Takaya's beloved bestselling Fruits Basket series returns to print in gorgeous deluxe English-language omnibus editions with beautiful full-color illustrations that are not to be missed!",
pages: "392",
publishData: "June 28, 2016",
dimensions: "5.7 X 8.0 X 1.4 inches | 1.14 pounds"
},
{  id:18,
image: "https://s2.uupload.ir/files/the_cardboard_kingdom_6yp.jpg",
category: "cooking",

title: "The Cardboard Kingdom",
Author: "Chad Sell",
price: 19.26,
describtion:
"Perfect for fans of Raina Telgemeier, Awkward, and All's Faire in Middle School, this graphic novel follows a neighborhood of kids who transform ordinary cardboard into fantastical homemade costumes as they explore conflicts with friends, family, and their own identity.A breath of fresh air, this tender and dynamic collection is a must-have. --Kirkus, Starred Welcome to a neighborhood of kids who transform ordinary boxes into colorful costumes, and their ordinary block into cardboard kingdom. This is the summer when sixteen kids encounter knights and rogues, robots and monsters--and their own inner demons--on one last quest before school starts again.",
pages: "288",
publishData: "June 05, 2018",
dimensions: "5.9 X 8.1 X 0.9 inches | 1.35 pounds"
},
{  id:19,
image: "https://s2.uupload.ir/files/9780399186783_koy0.jpg",
category: "cooking",

title: "Birdie and Me",
Author: "J. M. M. Nuanez   ",
price: 8.66,
describtion:
"Birdie, searching for the place where they can be their true and best selves.After their mama dies, Jack and Birdie find themselves without a place to call home. And when Mama's two brothers each try to provide one--first sweet Uncle Carl, then gruff Uncle Patrick--the results are funny, tender, and tragic.They're also somehow . . . spectacular.With voices and characters that soar off the page, J. M. M. Nuanez's debut novel depicts an unlikely family caught in a situation none of them would have chosen, and the beautiful ways in which they finally come to understand one another.",
pages: "256",
publishData: "February 16, 2021",
dimensions: "5.0 X 7.7 X 0.8 inches | 0.42 pounds"
},{  id:20,
image: "https://s2.uupload.ir/files/yotsuba_amp__2xfp.jpg",
category: "cooking",

title: "Yotsuba&!",
Author: "Kiyohiko Azuma ",
price:12.9 ,
describtion:
"Hello! This is Koiwai Yotsuba, Yotsuba Koiwai...um, YOTSUBA! Yotsuba moved with Daddy to a new house from our old house waaaaaaay over there! And moving's fun 'cos people wave! (Ohhhh!!) And Yotsuba met these nice people next door and made friends to play with (one of 'em acted like one of those bad strangers Daddy told Yotsuba not to go with, but it was okay in the end). I hope we get to play a lot. And eat ice cream! And-and-and...oh yeah! You should come play with Yotsuba too!",
pages: "208",
publishData: "September 01, 2009",
dimensions: "5.1 X 7.54 X 0.69 inches | 0.48 pounds"
},{
  id:21,
image: "https://s2.uupload.ir/files/the_stonekeeper_lpqf.jpg",
category: "cooking",

title: "The Stonekeeper ",
Author: "Kazu Kibuishi",
price: 19.52,
describtion:"The first book in Kazu Kibuishi's #1 New York Times bestselling series that features a beautiful but dangerous world of new friends, giant robots, and shadowy enemies!After the tragic death of their father, Emily and Navin move with their mother to the home of her deceased great-grandfather. The strange house proves to be dangerous. Before long, a tentacled creature lures the kids' mom through a door in the basement"
,pages: "192",
publishData: "June 05 , 2018",
dimensions: "6 * 8.1 * .5 inches"
},{
id:22,
image: "https://s2.uupload.ir/files/fruits_89wy.jpg",
category: "cooking",

title: "Basket Collector's Edition",
Author: "Natsuki Takaya",
price:18.60 ,
describtion:
"After a family tragedy turns her life upside down, plucky high schooler Tohru Honda takes matters into her own hands and moves out...into a tent! Unfortunately for her, she pitches her new home on private land belonging to the mysterious Sohma clan, and it isn't long before the owners discover her secret.But, as Tohru quickly finds out when the family offers to take her in, the Sohmas have a secret of their own--when touched by the opposite sex, they turn into the animals of the Chinese Zodiac!A perennial favorite of fans and librarians alike, Natsuki Takaya's beloved bestselling Fruits Basket series returns to print in gorgeous deluxe English-language omnibus editions with beautiful full-color illustrations that are not to be missed!",
pages: "392",
publishData: "June 28, 2016",
dimensions: "5.7 X 8.0 X 1.4 inches | 1.14 pounds"
},
{  id:23,
image: "https://s2.uupload.ir/files/the_cardboard_kingdom_6yp.jpg",
category: "cooking",

title: "The Cardboard Kingdom",
Author: "Chad Sell",
price: 19.26,
describtion:
"Perfect for fans of Raina Telgemeier, Awkward, and All's Faire in Middle School, this graphic novel follows a neighborhood of kids who transform ordinary cardboard into fantastical homemade costumes as they explore conflicts with friends, family, and their own identity.A breath of fresh air, this tender and dynamic collection is a must-have. --Kirkus, Starred Welcome to a neighborhood of kids who transform ordinary boxes into colorful costumes, and their ordinary block into cardboard kingdom. This is the summer when sixteen kids encounter knights and rogues, robots and monsters--and their own inner demons--on one last quest before school starts again.",
pages: "288",
publishData: "June 05, 2018",
dimensions: "5.9 X 8.1 X 0.9 inches | 1.35 pounds"
},
{  id:24,
image: "https://s2.uupload.ir/files/9780399186783_koy0.jpg",
category: "love",

title: "Birdie and Me",
Author: "J. M. M. Nuanez   ",
price: 8.66,
describtion:
"Birdie, searching for the place where they can be their true and best selves.After their mama dies, Jack and Birdie find themselves without a place to call home. And when Mama's two brothers each try to provide one--first sweet Uncle Carl, then gruff Uncle Patrick--the results are funny, tender, and tragic.They're also somehow . . . spectacular.With voices and characters that soar off the page, J. M. M. Nuanez's debut novel depicts an unlikely family caught in a situation none of them would have chosen, and the beautiful ways in which they finally come to understand one another.",
pages: "256",
publishData: "February 16, 2021",
dimensions: "5.0 X 7.7 X 0.8 inches | 0.42 pounds"
},{  id:25,
image: "https://s2.uupload.ir/files/yotsuba_amp__2xfp.jpg",
category: "love",

title: "Yotsuba&!",
Author: "Kiyohiko Azuma ",
price:12.9 ,
describtion:
"Hello! This is Koiwai Yotsuba, Yotsuba Koiwai...um, YOTSUBA! Yotsuba moved with Daddy to a new house from our old house waaaaaaay over there! And moving's fun 'cos people wave! (Ohhhh!!) And Yotsuba met these nice people next door and made friends to play with (one of 'em acted like one of those bad strangers Daddy told Yotsuba not to go with, but it was okay in the end). I hope we get to play a lot. And eat ice cream! And-and-and...oh yeah! You should come play with Yotsuba too!",
pages: "208",
publishData: "September 01, 2009",
dimensions: "5.1 X 7.54 X 0.69 inches | 0.48 pounds"
},{
  id:26,
image: "https://s2.uupload.ir/files/the_stonekeeper_lpqf.jpg",
category: "comedy",

title: "The Stonekeeper ",
Author: "Kazu Kibuishi",
price: 19.52,
describtion:"The first book in Kazu Kibuishi's #1 New York Times bestselling series that features a beautiful but dangerous world of new friends, giant robots, and shadowy enemies!After the tragic death of their father, Emily and Navin move with their mother to the home of her deceased great-grandfather. The strange house proves to be dangerous. Before long, a tentacled creature lures the kids' mom through a door in the basement"
,pages: "192",
publishData: "June 05 , 2018",
dimensions: "6 * 8.1 * .5 inches"
},{
id:27,
image: "https://s2.uupload.ir/files/fruits_89wy.jpg",
category: "comedy",

title: "Basket Collector's Edition",
Author: "Natsuki Takaya",
price:18.60 ,
describtion:
"After a family tragedy turns her life upside down, plucky high schooler Tohru Honda takes matters into her own hands and moves out...into a tent! Unfortunately for her, she pitches her new home on private land belonging to the mysterious Sohma clan, and it isn't long before the owners discover her secret.But, as Tohru quickly finds out when the family offers to take her in, the Sohmas have a secret of their own--when touched by the opposite sex, they turn into the animals of the Chinese Zodiac!A perennial favorite of fans and librarians alike, Natsuki Takaya's beloved bestselling Fruits Basket series returns to print in gorgeous deluxe English-language omnibus editions with beautiful full-color illustrations that are not to be missed!",
pages: "392",
publishData: "June 28, 2016",
dimensions: "5.7 X 8.0 X 1.4 inches | 1.14 pounds"
},
{  id:28,
image: "https://s2.uupload.ir/files/the_cardboard_kingdom_6yp.jpg",
category: "comedy",

title: "The Cardboard Kingdom",
Author: "Chad Sell",
price: 19.26,
describtion:
"Perfect for fans of Raina Telgemeier, Awkward, and All's Faire in Middle School, this graphic novel follows a neighborhood of kids who transform ordinary cardboard into fantastical homemade costumes as they explore conflicts with friends, family, and their own identity.A breath of fresh air, this tender and dynamic collection is a must-have. --Kirkus, Starred Welcome to a neighborhood of kids who transform ordinary boxes into colorful costumes, and their ordinary block into cardboard kingdom. This is the summer when sixteen kids encounter knights and rogues, robots and monsters--and their own inner demons--on one last quest before school starts again.",
pages: "288",
publishData: "June 05, 2018",
dimensions: "5.9 X 8.1 X 0.9 inches | 1.35 pounds"
},
{  id:29,
image: "https://s2.uupload.ir/files/9780399186783_koy0.jpg",
category: "comedy",

title: "Birdie and Me",
Author: "J. M. M. Nuanez   ",
price: 8.66,
describtion:
"Birdie, searching for the place where they can be their true and best selves.After their mama dies, Jack and Birdie find themselves without a place to call home. And when Mama's two brothers each try to provide one--first sweet Uncle Carl, then gruff Uncle Patrick--the results are funny, tender, and tragic.They're also somehow . . . spectacular.With voices and characters that soar off the page, J. M. M. Nuanez's debut novel depicts an unlikely family caught in a situation none of them would have chosen, and the beautiful ways in which they finally come to understand one another.",
pages: "256",
publishData: "February 16, 2021",
dimensions: "5.0 X 7.7 X 0.8 inches | 0.42 pounds"
},{  id:30,
image: "https://s2.uupload.ir/files/yotsuba_amp__2xfp.jpg",
category: "comedy",

title: "Yotsuba&!",
Author: "Kiyohiko Azuma ",
price:12.9 ,
describtion:
"Hello! This is Koiwai Yotsuba, Yotsuba Koiwai...um, YOTSUBA! Yotsuba moved with Daddy to a new house from our old house waaaaaaay over there! And moving's fun 'cos people wave! (Ohhhh!!) And Yotsuba met these nice people next door and made friends to play with (one of 'em acted like one of those bad strangers Daddy told Yotsuba not to go with, but it was okay in the end). I hope we get to play a lot. And eat ice cream! And-and-and...oh yeah! You should come play with Yotsuba too!",
pages: "208",
publishData: "September 01, 2009",
dimensions: "5.1 X 7.54 X 0.69 inches | 0.48 pounds"
},{  id:31,
  image: "https://s2.uupload.ir/files/yotsuba_amp__2xfp.jpg",
  category: "love",
  
  title: "Yotsuba&!",
  Author: "Kiyohiko Azuma ",
  price:12.9 ,
  describtion:
  "Hello! This is Koiwai Yotsuba, Yotsuba Koiwai...um, YOTSUBA! Yotsuba moved with Daddy to a new house from our old house waaaaaaay over there! And moving's fun 'cos people wave! (Ohhhh!!) And Yotsuba met these nice people next door and made friends to play with (one of 'em acted like one of those bad strangers Daddy told Yotsuba not to go with, but it was okay in the end). I hope we get to play a lot. And eat ice cream! And-and-and...oh yeah! You should come play with Yotsuba too!",
  pages: "208",
  publishData: "September 01, 2009",
  dimensions: "5.1 X 7.54 X 0.69 inches | 0.48 pounds"
  },{
    id:32,
  image: "https://s2.uupload.ir/files/the_stonekeeper_lpqf.jpg",
  category: "classic",
  
  title: "The Stonekeeper ",
  Author: "Kazu Kibuishi",
  price: 19.52,
  describtion:"The first book in Kazu Kibuishi's #1 New York Times bestselling series that features a beautiful but dangerous world of new friends, giant robots, and shadowy enemies!After the tragic death of their father, Emily and Navin move with their mother to the home of her deceased great-grandfather. The strange house proves to be dangerous. Before long, a tentacled creature lures the kids' mom through a door in the basement"
  ,pages: "192",
  publishData: "June 05 , 2018",
  dimensions: "6 * 8.1 * .5 inches"
  },{
  id:33,
  image: "https://s2.uupload.ir/files/fruits_89wy.jpg",
  category: "classic",
  
  title: "Basket Collector's Edition",
  Author: "Natsuki Takaya",
  price:18.60 ,
  describtion:
  "After a family tragedy turns her life upside down, plucky high schooler Tohru Honda takes matters into her own hands and moves out...into a tent! Unfortunately for her, she pitches her new home on private land belonging to the mysterious Sohma clan, and it isn't long before the owners discover her secret.But, as Tohru quickly finds out when the family offers to take her in, the Sohmas have a secret of their own--when touched by the opposite sex, they turn into the animals of the Chinese Zodiac!A perennial favorite of fans and librarians alike, Natsuki Takaya's beloved bestselling Fruits Basket series returns to print in gorgeous deluxe English-language omnibus editions with beautiful full-color illustrations that are not to be missed!",
  pages: "392",
  publishData: "June 28, 2016",
  dimensions: "5.7 X 8.0 X 1.4 inches | 1.14 pounds"
  },
  {  id:34,
  image: "https://s2.uupload.ir/files/the_cardboard_kingdom_6yp.jpg",
  category: "classic",
  
  title: "The Cardboard Kingdom",
  Author: "Chad Sell",
  price: 19.26,
  describtion:
  "Perfect for fans of Raina Telgemeier, Awkward, and All's Faire in Middle School, this graphic novel follows a neighborhood of kids who transform ordinary cardboard into fantastical homemade costumes as they explore conflicts with friends, family, and their own identity.A breath of fresh air, this tender and dynamic collection is a must-have. --Kirkus, Starred Welcome to a neighborhood of kids who transform ordinary boxes into colorful costumes, and their ordinary block into cardboard kingdom. This is the summer when sixteen kids encounter knights and rogues, robots and monsters--and their own inner demons--on one last quest before school starts again.",
  pages: "288",
  publishData: "June 05, 2018",
  dimensions: "5.9 X 8.1 X 0.9 inches | 1.35 pounds"
  },
  {  id:35,
  image: "https://s2.uupload.ir/files/9780399186783_koy0.jpg",
  category: "classic",
  
  title: "Birdie and Me",
  Author: "J. M. M. Nuanez   ",
  price: 8.66,
  describtion:
  "Birdie, searching for the place where they can be their true and best selves.After their mama dies, Jack and Birdie find themselves without a place to call home. And when Mama's two brothers each try to provide one--first sweet Uncle Carl, then gruff Uncle Patrick--the results are funny, tender, and tragic.They're also somehow . . . spectacular.With voices and characters that soar off the page, J. M. M. Nuanez's debut novel depicts an unlikely family caught in a situation none of them would have chosen, and the beautiful ways in which they finally come to understand one another.",
  pages: "256",
  publishData: "February 16, 2021",
  dimensions: "5.0 X 7.7 X 0.8 inches | 0.42 pounds"
  },{  id:36,
  image: "https://s2.uupload.ir/files/yotsuba_amp__2xfp.jpg",
  category: "classic",
  
  title: "Yotsuba&!",
  Author: "Kiyohiko Azuma ",
  price:12.9 ,
  describtion:
  "Hello! This is Koiwai Yotsuba, Yotsuba Koiwai...um, YOTSUBA! Yotsuba moved with Daddy to a new house from our old house waaaaaaay over there! And moving's fun 'cos people wave! (Ohhhh!!) And Yotsuba met these nice people next door and made friends to play with (one of 'em acted like one of those bad strangers Daddy told Yotsuba not to go with, but it was okay in the end). I hope we get to play a lot. And eat ice cream! And-and-and...oh yeah! You should come play with Yotsuba too!",
  pages: "208",
  publishData: "September 01, 2009",
  dimensions: "5.1 X 7.54 X 0.69 inches | 0.48 pounds"
  },


]


